export default "__VITE_ASSET__09OK8AuL__"